/*----------------------------------------------------

	onload.js

----------------------------------------------------*/

// to loop over a nodeList (i.e. the result of querySelectorAll)
var forEach = function (array, callback, scope) {
 for (var i = 0; i < array.length; i++) {
   callback.call(scope, i, array[i]); // passes back stuff we need
 }
};

// is visible
function isVisible(obj){
  return obj.offsetWidth > 0 && obj.offsetHeight > 0;
}

// closest polyfill
if (!Element.prototype.matches)
    Element.prototype.matches = Element.prototype.msMatchesSelector ||
                                Element.prototype.webkitMatchesSelector;

if (!Element.prototype.closest)
    Element.prototype.closest = function(s) {
        var el = this;
        if (!document.documentElement.contains(el)) return null;
        do {
            if (el.matches(s)) return el;
            el = el.parentElement || el.parentNode;
        } while (el !== null && el.nodeType === 1);
        return null;
    };


// A. dynamic loading
// -----------------------------------------------------------------------------------

function loadScript(url){
  (function(document, tag) {
      var scriptTag = document.createElement(tag), // create a script tag
          firstScriptTag = document.getElementsByTagName(tag)[0]; // find the first script tag in the document
      scriptTag.src = url; // set the source of the script to your script
      firstScriptTag.parentNode.insertBefore(scriptTag, firstScriptTag); // append the script to the DOM
  }(document, 'script'));
}

function loadCSS(url){
  var head = document.getElementsByTagName('head')[0];
  var link  = document.createElement('link');
  link.rel  = 'stylesheet';
  link.type = 'text/css';
  link.href = url;
  head.appendChild(link);
}

// googlemaps
if(document.querySelectorAll('.map-canvas').length > 0){
  loadScript(stylesheet_directory_uri + '/inc/js/googlemaps.js');
}



// B. scroll to anchor
// -----------------------------------------------------------------------------------

function getScrollTop(){
    if(typeof pageYOffset!= 'undefined'){
        //most browsers except IE before #9
        return pageYOffset;
    }
    else{
        var B= document.body; //IE 'quirks'
        var D= document.documentElement; //IE with doctype
        D= (D.clientHeight)? D: B;
        return D.scrollTop;
    }
}

// used to make sure offset is based on document and not parent
function offset(elt) {
  //var rect = elt.getBoundingClientRect(), bodyElt = document.documentElement;
  //var rect = elt.getBoundingClientRect(), bodyElt = document.body;
  var rect = elt.getBoundingClientRect(), bodyElt = getScrollTop();
  return {
    top: rect.top + bodyElt,
    //left: rect.left + bodyElt.scrollLeft
  }
}

// Function to animate the scroll
var smoothScroll = function (anchor, duration){

  // Calculate how far and how fast to scroll
  var startLocation = window.pageYOffset;
  var endLocation = offset(anchor).top;
  //var endLocation = anchor.offsetTop;
  var distance = endLocation - startLocation;
  var increments = distance/(duration/16);
  var stopAnimation;

  // Scroll the page by an increment, and check if it's time to stop
  var animateScroll = function(){
    window.scrollBy(0, increments);
    stopAnimation();
  };

  // If scrolling down
  if(increments >= 0){
    // Stop animation when you reach the anchor OR the bottom of the page
    stopAnimation = function(){
      var travelled = window.pageYOffset;
      if((travelled >= (endLocation - increments)) || ((window.innerHeight + travelled) >= document.body.offsetHeight)){
        clearInterval(runAnimation);
      }
    };
  }

  // If scrolling up
  else {

    // Stop animation when you reach the anchor OR the top of the page
    stopAnimation = function(){
      var travelled = window.pageYOffset;
      if(travelled <= (endLocation || 0)){
        clearInterval(runAnimation);
      }
    };

  }

  // Loop the animation function
  var runAnimation = setInterval(animateScroll, 16);

};


(function(){

  'use strict';

  // Feature Test
  if('querySelector' in document && 'addEventListener' in window && Array.prototype.forEach){

    // Define smooth scroll links
    var scrollToggle = document.querySelectorAll('.scroll-link');

    // For each smooth scroll link
    [].forEach.call(scrollToggle, function(toggle){

      // When the smooth scroll link is clicked
      toggle.addEventListener('click', function(e){

        // Prevent the default link behavior
        e.preventDefault();

        // Get anchor link and calculate distance from the top
        var dataID = toggle.getAttribute('href');
        var dataTarget = document.querySelector(dataID);
        var dataSpeed = toggle.getAttribute('data-speed');

        // If the anchor exists
        if(dataTarget){
          // Scroll to the anchor
          smoothScroll(dataTarget, dataSpeed || 500);
        }

      }, false);

    });

  }

})();


// C. external links in new tab
// -----------------------------------------------------------------------------------

var links = document.links;

for (var i = 0, linksLength = links.length; i < linksLength; i++) {
  if(links[i].hostname != window.location.hostname && links[i].href.substr(0,7)!='mailto:'){
    links[i].target = '_blank';
  }
}


// D. offcanvas navigation
// -----------------------------------------------------------------------------------

var offcanvas_open_link = document.querySelector('.offcanvas-toggle');
var offcanvas_close_link = document.querySelector('.offcanvas__close');
var offcanvas_outer = document.querySelector('.offcanvas-outer');
var offcanvas_menu = document.querySelector('.offcanvas');


// open offcanvas
offcanvas_open_link.addEventListener('click', function(ev){

  ev.preventDefault();
  ev.stopPropagation();

  offcanvas_outer.style.display = 'block';
  offcanvas_outer.classList.remove('fade-out');
  offcanvas_outer.classList.add('fade-in'); // relying on support for css keyframe animation

  start_left = -Math.abs(parseInt(getComputedStyle(offcanvas_menu).width));
  end = 0;
  animateRight();

});


// close offcanvas
function closeOffcanvas(ev){

  // animate menu
  end = start_left;
  animateLeft();

  // fade out background
  offcanvas_outer.classList.remove('fade-in');
  offcanvas_outer.classList.add('fade-out');
  setTimeout(function(){
    offcanvas_outer.setAttribute('style','');
  }, 500)

}


// things that close offcanvas
// close button
offcanvas_close_link.addEventListener('click', function(ev){

	ev.preventDefault();
	ev.stopPropagation();

	closeOffcanvas();

});


// outside offcanvas
document.addEventListener('click', function(ev){
  if(isVisible(offcanvas) && isVisible(offcanvas_open_link) && ev.target !== offcanvas_menu && !offcanvas_menu.contains(ev.target)){
		closeOffcanvas();
	}
});


// menu link - can't quite figure out in what instance this runs
/*offcanvas_menu.querySelectorAll('a').addEventListener('click', function(ev){
  if(!this.classList.contains('has-children')){
    if(isVisible(offcanvas_open_link) && ev.target !== offcanvas_menu && !offcanvas_menu.contains(ev.target)){
      closeOffcanvas();
    }
  }
});*/


// used to slide menu in
function animateRight(){
  var cur = parseInt(window.getComputedStyle(offcanvas_menu).left);
  if(isNaN(cur)){
    cur = -Math.abs(parseInt(getComputedStyle(offcanvas_menu).width)); // for iOS that won't get left on initial run
  }
  setTimeout(function(){
    if(cur < end){
      to_move = cur + 8 + 'px';
      to_move = (parseInt(to_move) > 0) ? '0px' : to_move; // ensure menu doesn't go above 0
      offcanvas_menu.style.left = to_move;
      animateRight();
    }
  }, 5);
}

// used to slide menu out
function animateLeft(){
  var cur = parseInt(getComputedStyle(offcanvas_menu).left);
  setTimeout(function(){
    if(cur > end){
      offcanvas_menu.style.left = cur - 8 + 'px';
      animateLeft();
    }
  }, 5);
}

// is visible
function isVisible(obj){
  return obj.offsetWidth > 0 && obj.offsetHeight > 0;
}


// E. dropdown navigation
// -----------------------------------------------------------------------------------

(function(){

  'use strict';

  // Feature Test
  if('querySelector' in document && 'addEventListener' in window && Array.prototype.forEach){

    // Define nav links with children
    var hasChildren = document.querySelectorAll('.has-children');

    [].forEach.call(hasChildren, function(link){

      // When the link is clicked
      link.addEventListener('click', function(ev){

        // Prevent the default link behavior
				ev.preventDefault();
			  ev.stopPropagation();

        var sub_nav = link.nextSibling;

        if(isVisible(sub_nav)){
          link.nextSibling.style.display = '';
        }else{
          link.nextSibling.style.display = 'block';
        }

      }, false);

    });

  }

})();

// outside submenu
document.addEventListener('click', function(ev){

  var sub_navs = document.querySelectorAll('.the-navigation__child');

  [].forEach.call(sub_navs, function(this_nav){

    if(isVisible(this_nav) && ev.target !== this_nav && !this_nav.contains(ev.target)){
  		this_nav.style.display = '';
  	}

  });

});


// F. JS / bubble links
// -----------------------------------------------------------------------------------
// requires closest polyfill

document.addEventListener('click',function(e){
  if(e.target && e.target.className == 'js-link' || e.target.closest('.js-link')){
    e.preventDefault();
    var destination = e.target.closest('.js-link').querySelectorAll('a')[0].getAttribute('href');
    if(e.ctrlKey || e.target.closest('.js-link').getAttribute('target') == '_blank'){
      window.open(destination,'_blank')
    }else{
      window.location.href = destination;
    }
    return false;
  }
});


// G. testimonial switcher
// -----------------------------------------------------------------------------------

(function(){

  'use strict';

  if(document.querySelectorAll('.index__testimonials').length > 0){

    var testimonial = document.querySelector('.index__testimonials').querySelector('.content-block');

    // create and append paging
    buildTestimonialPaging(testimonial);

  }

})();

function buildTestimonialPaging(parent){

  var paging = document.createElement("div");
  paging.className = "testimonial__paging";
  paging.innerHTML = '<a href="#" data-direction="prev" class="testimonial__paging__item"><svg viewBox="0 0 100 100" class="icon icon-arrow-left"><use xlink:href="#arrow-left"></use></svg><span class="screen-reader-text">Previous</span></a> <a href="#" data-direction="next" class="testimonial__paging__item"><svg viewBox="0 0 100 100" class="icon icon-arrow-right"><use xlink:href="#arrow-right"></use></svg><span class="screen-reader-text">Next</span></a>';
  parent.appendChild(paging);


  var paging_links = document.querySelectorAll('.testimonial__paging__item');

  // For each smooth scroll link
  [].forEach.call(paging_links, function(link){

    link.addEventListener('click', function(e){

      // Prevent the default link behavior
      e.preventDefault();


      // Get direction and id
      var testimonial = document.querySelector('.testimonial');
      var direction = link.getAttribute('data-direction');

      if(direction == 'prev'){
        var new_id = testimonial.getAttribute('data-prev');
      }else{
        var new_id = testimonial.getAttribute('data-next');
      }

      // load new testimonial
      getTestimonial(new_id);

    }, false);

  });

}

function getTestimonial(id){

  var testimonial = document.querySelector('.testimonial');

  var xhr = new XMLHttpRequest();
  xhr.onreadystatechange = function(){
      if(xhr.readyState == XMLHttpRequest.DONE){
          if(xhr.status == 200){

              var data = JSON.parse(xhr.responseText);
              var parent = testimonial.parentNode,

              tempDiv = document.createElement('div');
              tempDiv.innerHTML = data;
              var input = tempDiv.childNodes[0];
              parent.replaceChild(input, testimonial);

              //buildTestimonialPaging(document.querySelector('.testimonial--indexgallery').querySelector('.content-block'));

         }
      }
  };

  // TRIGGER AJAX
  xhr.open("GET", '/wp-json/alglas/v1/testimonial/' + id, true);
  xhr.send();

}


// H. generic showhide
// -----------------------------------------------------------------------------------

var showhide_links = document.querySelectorAll('[data-showhide]');

// For each smooth scroll link
[].forEach.call(showhide_links, function(link){

  link.addEventListener('click', function(ev){

    // Prevent the default link behavior
    ev.preventDefault();
    ev.stopPropagation();

    var target = document.querySelector(link.getAttribute('href'));

    if(isVisible(target)){
      target.style.display = 'none';
      target.removeAttribute('style');
    }else{
      closeShowHide(ev);
      target.style.display = 'block';
    }

  });

});


function closeShowHide(ev){
  var docclose = document.querySelectorAll('[data-docclose]');

  [].forEach.call(docclose, function(link){
    if(isVisible(link) && ev.target !== link && !link.contains(ev.target)){
      link.style.display = 'none';
      link.removeAttribute('style');
    }
  });
}

document.addEventListener('click', function(ev){
  closeShowHide(ev);
});



// I. filter auto submit
// -----------------------------------------------------------------------------------

var filter_regions = document.querySelectorAll('.form__filter__items input');

// For each smooth scroll link
[].forEach.call(filter_regions, function(input){

  input.addEventListener('change', function(ev){

    input.closest('form').submit();

  });

});
